import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GalerieBulevart } from '../bulevart.interface';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-view-bulevart-image',
    templateUrl: './view-bulevart-image.component.html',
    styleUrls: ['./view-bulevart-image.component.scss']
})
export class ViewBulevartImageComponent {
    private basePath = environment.interop.basePath;
    imageSrc = '';
    imageLoading = true;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: GalerieBulevart,
        private dialogRef: MatDialogRef<ViewBulevartImageComponent>
    ) {
        // Need to remove the first character '/' in full_display
        this.imageSrc = this.basePath + data.full_display.slice(1);
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }
}
